"use client";

import { useCallback } from "react";
import { useI18nContext } from "./provider";
import { Language } from "./types";

export function useI18n() {
  const { language, t, setLanguage } = useI18nContext();

  const translate = useCallback(
    (key: string, params?: Record<string, string | number>) => {
      return t(key, params);
    },
    [t]
  );

  return {
    language,
    t: translate,
    setLanguage,
  };
}
